import { render, staticRenderFns } from "./PageOverviewItem.vue?vue&type=template&id=5114aaf7&"
import script from "./PageOverviewItem.vue?vue&type=script&lang=ts&"
export * from "./PageOverviewItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports